module.exports = __webpack_public_path__ + "static/media/slide (7).14d8ac67.jpg";